<template>
  <div>
    <p class="doctitle">{{ data.doc_title }}</p>
    <div v-if="data.video_url" style="text-align: center">
      <video :src="data.video_url" width="500" height="400" controls />
    </div>
    <div class="ql-container ql-snow">
      <div class="ql-editor">
        <div v-html="content" />
      </div>
    </div>
  </div>
</template>

<script>
import { getDocContent } from '@/api/docmenu'
export default {
  data() {
    return {
      content: '',
      title: '',
      data: {}
    }
  },
  created() {
    getDocContent({ id: this.$route.params.id }).then(res => {
      this.data = res.data[0]
      this.content = this.data.content
      this.title = this.data.doc_title
    })
  }
}
</script>

<style scoped>
.doctitle {
  position: relative;
  bottom: 12px;
  font-size: 34px;
  text-align: center;
  margin-bottom: 10px;
  overflow-wrap: anywhere;
}
.ql-snow {
  border: none !important;
}
</style>
